import TTLCache from '@isaacs/ttlcache';
export class SimpleCache {
    cache;
    pendingFetches = new Map();
    /**
     * @param ttlSeconds Optional time-to-live for cache entries in seconds. If not provided, cache entries do not expire.
     * @param maxSize Optional maximum number of entries in the cache.
     */
    constructor(args = {}) {
        const ttlSeconds = args.ttlSeconds !== undefined ? args.ttlSeconds * 1000 : Infinity;
        const maxSize = args.maxSize ?? 10_000;
        this.cache = new TTLCache({
            ttl: ttlSeconds,
            max: maxSize,
        });
    }
    get(key) {
        return this.cache.get(key.toKey());
    }
    add(key, value) {
        this.cache.set(key.toKey(), value);
    }
    remove(key) {
        this.cache.delete(key.toKey());
    }
    clear() {
        this.cache.clear();
    }
    /**
     * Executes a function to fetch a value if it's not in the cache,
     * stores the result, and returns it.
     */
    async executeUsingCache(key, fetchFn) {
        const cacheKey = key.toKey();
        // 1. Check main cache
        const cachedValue = this.cache.get(cacheKey);
        if (cachedValue !== undefined) {
            return cachedValue;
        }
        // 2. Check for pending fetch
        const pendingPromise = this.pendingFetches.get(cacheKey);
        if (pendingPromise) {
            return pendingPromise; // Return existing promise
        }
        // 3. No cached value, no pending fetch: Initiate fetch
        const fetchPromise = fetchFn(key).catch((err) => {
            this.pendingFetches.delete(cacheKey);
            throw err;
        });
        this.pendingFetches.set(cacheKey, fetchPromise);
        try {
            const fetchedValue = await fetchPromise;
            // Add to main cache only on successful fetch
            this.cache.set(cacheKey, fetchedValue);
            return fetchedValue;
        }
        finally {
            // Remove from pending fetches regardless of success or failure
            this.pendingFetches.delete(cacheKey);
        }
    }
}
//# sourceMappingURL=SimpleCache.js.map